import axios from 'axios'
import moment from 'moment-timezone'

const state = {
  publicHolidays: undefined,
  resources: undefined,
}

const mutations = {
  SET_PUBLIC_HOLIDAYS(state, publicHolidays) {
    state.publicHolidays = publicHolidays
  },
  SET_RESOURCES(state, resources) {
    state.resources = resources
  },
}

let cache = {}

const actions = {
  // just get this on load, for the remainder of this year and next
  async setPublicHolidays({ commit, dispatch, state }) {
    if (!state.publicHolidays) {
      const response = await axios.get('/api/util/holidays')
      const holidays = response.data
      commit('SET_PUBLIC_HOLIDAYS', holidays)
    }
  },
  getPublicHolidaysForMonth: async ({ commit, dispatch, state }, theDate) => {
    if (!state.publicHolidays) {
      await actions.setPublicHolidays({ commit, dispatch, state })
    }

    const thisMonthsHolidays = state.publicHolidays
      .filter(holiday => {
        return moment.tz(holiday.date, moment.tz.guess()).isSame(moment.tz(theDate, moment.tz.guess()), 'month')
      })
      .map(publicHoliday => {
        return publicHoliday.date
      })

    return thisMonthsHolidays
  },

  updateResources: async ({ commit }) => {
    const result = await axios.get('/api/resource')
    const resources = result.data ? result.data.resources : []
    commit('SET_RESOURCES', resources)
  },
}

const getters = {
  findResourceById: state => resourceId => {
    return state.resources.find(resource => {
      return resource._id === resourceId
    })
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
